var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"logo",class:{ collapse: _vm.adminCollapse }},[_c('span',[_vm._v("UMS")]),_c('span',{staticClass:"label"},[_vm._v("综合管理平台")])])
}
var staticRenderFns = []

export { render, staticRenderFns }